import api from './api'

/**
 * Serviço de Configurações do Tenant (TENANT_ADMIN)
 * 
 * Backend: /api/tenant/settings  e  /api/tenants/:id
 */
export default {
  /**
   * Obter todas as configurações do tenant (endpoint legado)
   * GET /api/tenant/settings
   */
  getSettings() {
    return api.get('/api/tenant/settings')
  },

  /**
   * Obter dados completos do tenant pelo ID
   * GET /api/tenants/:id
   */
  getTenantById(tenantId) {
    return api.get(`/api/tenants/${tenantId}`)
  },

  /**
   * Atualizar configurações do tenant (endpoint legado)
   * PUT /api/tenant/settings
   * 
   * Payload: { dadosEmpresa, responsavelContrato, informacoesContrato, configuracoesAcesso }
   */
  updateSettings(payload) {
    return api.put('/api/tenant/settings', payload)
  },

  /**
   * Atualizar dados do tenant
   * PUT /api/tenants/:id
   */
  updateTenant(tenantId, payload) {
    return api.put(`/api/tenants/${tenantId}`, payload)
  },
}
